var General = {
	init: function () {
		// Making elements fully clickable.
		General.DataClickable();

		// Detect if the user is scrolling.
		General.DetectScrolling();

		// Executes all 'scope' dependent methods.
		General.contentChange(document);
	},

	/**
	 * Making entire elements clickable.
	 *
	 * Wrapping multiple elements inside an "a" element can be bad for SEO in some
	 * cases, this solution is very convenient. This function searches for
	 * elements that have the data-clickable="clickable" attribute, it then searches
	 * for the first 'a' element. Then it retrieves the href value and applies
	 * this value onclick so the users get redirected.
	 *
	 * Due to the increasing dynamicity of the portal, if some elements
	 * need to be bound to after the page has already loaded, this function
	 * can be called with a query selector to use to specifically bind
	 * to certain data-clickable elements.
	 *
	 * @param {string} [element] More specific query selector when rebinding
	 * @return void
	 */

	DataClickable: function (element = '') {
		Array.from(document.querySelectorAll(element + '[data-clickable="clickable"]')).forEach((clickable) => {
			clickable.addEventListener('mousedown', function (event) {
				// This resembles the scope (e.g. [data-clickable="clickable"]), this.target resembles the clicked element.
				var $link = this.querySelector('a');
				if (!$link) {
					console.error('General.DataClickable: No link found.');
					return;
				}

				if (this.querySelectorAll('a').length > 1) {
					console.error(
						'General.DataClickable: More then one link found, please limit yourself to one link per data-clickable element.',
						this
					);
					return;
				}

				// If the click is made directly on the <a> element then continue with the default behavior.
				if (event.target === $link || event.target.closest('a') === $link) {
					return;
				}

				var $newWindow = false;

				// User wants to open a new window.

				if (event.ctrlKey || event.button === 1) {
					$newWindow = true;
				}

				// User wants to open the context menu.

				if (event.button === 2) {
					return;
				}

				// If target is _blank or custom, open a new window as well.
				if (
					$link.hasAttribute('target') &&
					$link.getAttribute('target') !== '_self' &&
					$link.getAttribute('target') !== ''
				) {
					$newWindow = true;
				}

				if ($newWindow) {
					window.open($link.getAttribute('href'), $link.getAttribute('target'));
				} else {
					window.location = $link.getAttribute('href');
				}
			});
		});
	},

	/**
	 * Detects if the user is scrolling on page.
	 *
	 * If this is the case, there will be two custom events fired. This is the
	 * 'scrolledUp' or the 'scrolledDown' event.
	 *
	 * @return void
	 */

	DetectScrolling: function () {
		var $didScroll;
		var $lastScroll = 0;

		document.addEventListener('scroll', function () {
			$didScroll = true;

			// Check every 100ms if there has been scrolled.
			setInterval(function () {
				if ($didScroll) {
					hasScrolled();
					$didScroll = false;
				}
			}, 50);
		});

		/**
		 * This function check if the user has scrolled on the page
		 *
		 * @return void
		 */

		function hasScrolled() {
			// Get the current scroll position.
			var $scrollPosition = document.body.scrollTop;

			/**
			 * If the current position is bigger then the last position you scroll
			 * down (also on page refresh if you already scrolled). Otherwise you
			 * are scrolling up.
			 */

			if ($scrollPosition > $lastScroll) {
				// Scroll down.
				document.dispatchEvent(new Event('scrolledDown'));
			} else {
				// Scroll up.
				document.dispatchEvent(new Event('scrolledUp'));
			}

			// The last scrolling position is the current scroll position.
			$lastScroll = $scrollPosition;
		}
	},

	/**
	 * Check for all the empty module classes so it can attach a HTML class.
	 *
	 * @param $scope
	 * @constructor
	 * @return void;
	 */

	EmptyModules: function ($scope) {
		if (!$scope) {
			// Nothing to do here.
			return;
		}

		var modules = $scope.querySelectorAll('div.Module');
		if (!modules) {
			console.warn('General.EmptyModules: There are no modules present on the page');
			return;
		}

		Array.from(modules).forEach(function (element) {
			// If the innerHTML is empty then add the class 'EmptyModule'.
			if (element.innerHTML.trim().length === 0) {
				element.classList.add('EmptyModule');
			} else {
				element.classList.remove('EmptyModule');
			}
		});
	},

	/**
	 * Rewrites the values that can be displayed to localised values.
	 *
	 * @return void
	 */

	LocaleNumber: function ($scope) {
		if (!$scope) {
			// Nothing to do here.
			return;
		}

		const localeNumbers = $scope.querySelectorAll('.LocaleNumber, .js-localeNumber');

		for (let i = 0; i < localeNumbers.length; i++) {
			localeNumbers[i].formatAsNumber();
		}
	},

	/**
	 * Rewrites the values that can be displayed to localised values.
	 *
	 * @return void
	 */

	LocaleDateTime: function ($scope) {
		if (!$scope) {
			// Nothing to do here.
			return;
		}

		const localeDateTime = $scope.getElementsByTagName('time');

		for (let i = 0; i < localeDateTime.length; i++) {
			localeDateTime[i].formatAsDateTime();
		}
	},

	/**
	 * Method to contain al "dynamic" scope depend functions.
	 *
	 * @param $element
	 */

	contentChange: function ($element) {
		// Checks for all the empty modules.
		General.EmptyModules($element);

		// Rewrite numbers to localised integers.
		General.LocaleNumber($element);

		// Rewrite date and time to localised formats.
		General.LocaleDateTime($element);
	}
};

document.addEventListener('DOMContentLoaded', function () {
	General.init();
});

document.addEventListener('contentchange', function (event) {
	General.contentChange(event.detail.placeholder);
});

export default General;
